export const defaultWaypoint = {
  anchor: false,
  location: { name: '', address: '', placeId: '', id: '' },
  passengerIds: [],
  slug: '',
};

export const defaultWaypointAnchor = {
  anchor: true,
  location: { name: '', address: '', placeId: '', id: '' },
  passengerIds: [],
  slug: '',
};

const defaultSeriesAttributes = {
  startDate: null,
  endDate: null,
  interval: 1,
  interval_unit: 'weekly',
  sunday: false,
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
};

export const defaultSingleRideState: RideFormType = {
  timeAnchor: '',
  time: '',
  calendarSlug: '',
  anchorTime: null,
  waypointsAttributes: [defaultWaypoint, defaultWaypointAnchor],
  tagList: '',
  createdAt: null,
  updatedAt: null,
  startsAt: null,
  removedPassengers: [],
  status: '',
  waypoints: [],
};

export const defaultRideSeriesState: RideFormType = {
  timeAnchor: '',
  time: '',
  calendarSlug: '',
  anchorTime: null,
  waypointsAttributes: [defaultWaypoint, defaultWaypointAnchor],
  tripTemplateAttributes: defaultSeriesAttributes,
  tagList: '',
  createdAt: null,
  updatedAt: null,
  startsAt: null,
  removedPassengers: [],
  status: '',
  waypoints: [],
};
